export class Warehouse {
	warehouseid: number;
	warehousename: string;
	address: string;
	cityid: number;
	stateid: number;
	pincode: number;
	gstin: string;	
	warehousemanager: string;
	warehousemanagername: string;
	cityname: string;
	statename: string;
	mangerphoneno: string;
	active: number;	
    createon: Date;
	createdby:number;	
    modifiedon: Date;	
    modifiedby: number;
	warehousemanagerid: number;
	
}